<template>
  <footer>
    <img class="qrcode">
    <div class="foot_item" style="margin-left:180px">
      <div class="title">关于返猪</div>
      <div class="des">公司介绍</div>
      <div class="des">加入我们</div>
      <div class="des">企业历程</div>
      <div class="des">最新动态</div>
    </div>
    <div class="foot_item">
      <div class="title">用户服务</div>
      <div class="des">意见反馈</div>
      <div class="des">返猪协议</div>
      <div class="des">审查规范</div>
    </div>
    <div class="foot_item">
      <div class="title">产品与服务</div>
      <div class="des">网站建设</div>
      <div class="des">微信营销</div>
      <div class="des">建站快车</div>
      <div class="des">在线商城</div>
    </div>
    <div class="foot_item">
      <div class="title">商务合作</div>
      <div class="des">联系我们</div>
      <div class="des">加盟返猪</div>
      <div class="des">平台合作</div>
    </div>
    <div class="company" onclick="window.open('https://beian.miit.gov.cn')">江西聚小宝科技有限公司©2008-2020 赣ICP 备19013683 号</div>
  </footer>
</template>

<script>
import router from "../router";

export default {
  name: "footer",
  data() {
    return {
      navItems: navItems,
      src: "/static/img/dy_foot_bg.png",
    };
  },
  methods: {},
};
</script>

<style lang='scss'>
footer {
  width: 1920px;
  left: 0;
  height: 320px;
  background-color: #fafafa;
  position: relative;
}

.qrcode {
  width: 140px;
  height: 140px;
  background: url("/static/img/fz_qrcode.png");
  position: absolute;
  top: 53px;
  right: 180px;
}

.foot_item {
  width: 120px;
  height: 260px;
  float: left;
  margin-left: 60px;
}

.foot_item .title {
  font-size: 20px;
  font-family: SourceHanSansCN;
  font-weight: 500;
  color: #444444;
  margin-top: 53px;
  text-align: left;
  cursor: pointer;
}

.foot_item .des {
  font-size: 18px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #666666;
  margin-top: 15px;
  text-align: left;
  cursor: pointer;
}

.company {
  width: 1920px;
  height: 60px;
  background-color: #000;
  text-align: center;
  position: absolute;
  cursor: pointer;
  font-size: 16px;
  line-height: 60px;
  font-family: SourceHanSansCN;
  font-weight: 400;
  color: #a8a8a8;
  top: 260px;
}
</style>



// WEBPACK FOOTER //
// footer.vue?e0b99472